import { ApiError } from "../api/errors";
import type { HeroApi } from "../api/types";
import type { FeedFetchInput } from "./poller";

/** GET /feed только читает: новую переписку сначала запускает идемпотентный start. */
export function createChatFeed(api: Pick<HeroApi, "episodes" | "startEpisode" | "feed">, options: {
  onPaymentRequired(): void;
  onStartError(error: unknown | null): void;
}) {
  let started = false;
  let blocked = false;
  let starting: Promise<void> | null = null;

  async function start() {
    const episodes = (await api.episodes()).slice().sort((a, b) => a.ordinal - b.ordinal);
    const first = episodes.find((episode) => !episode.locked) ?? episodes[0];
    if (!first) throw new ApiError("not_found", 404, "No published episodes");
    await api.startEpisode(first.ordinal);
    started = true;
    options.onStartError(null);
  }

  return {
    retryStart() { blocked = false; },
    async fetch(input: FeedFetchInput) {
      if (!started && !blocked) {
        starting ??= start().finally(() => { starting = null; });
        try { await starting; }
        catch (error) {
          if (input.signal.aborted) throw error;
          if (error instanceof ApiError && error.code === "payment_required") {
            blocked = true;
            options.onStartError(null);
            options.onPaymentRequired();
          } else {
            options.onStartError(error);
            throw error;
          }
        }
      }
      if (input.signal.aborted) throw new ApiError("network", 0, "Aborted");
      return api.feed(input);
    },
  };
}
